import React from 'react';
import './Tiles.css';
import DashboardLinks from './DashboardLinks';
import { DashboardTile, SubDashboardLink } from '../../shared/types';

interface DashboardLink {
  name: string;
  url: string;
  tags: string[];
  description?: string;
  subDashboards?: SubDashboardLink[];
}

interface TilesProps {
  tiles: DashboardTile[];
  onDashboardClick?: (dashboard: DashboardLink) => void;
  selectedRole: string | null;
  searchQuery: string;
}

const Tiles: React.FC<TilesProps> = ({ tiles, onDashboardClick, selectedRole, searchQuery }) => {
  const handleDashboardClick = (dashboard: DashboardLink) => {
    if (onDashboardClick) {
      onDashboardClick(dashboard);
    }
  };

  return (
    <div className="tiles-container">
      <div className="tiles-grid">
        {tiles.length > 0 ? (
          tiles.map((tile, index) => (
            <div 
              key={tile.id || index} 
              className="tile"
            >
              <h3 className="tile-title">{tile.title}</h3>
              {tile.dashboards && tile.dashboards.length > 0 && (
                <DashboardLinks 
                  dashboards={tile.dashboards} 
                  onDashboardClick={handleDashboardClick}
                  selectedRole={selectedRole}
                  searchQuery={searchQuery}
                  tileName={tile.title}
                />
              )}
            </div>
          ))
        ) : (
          <div className="no-results">
            <p>No dashboards found matching your search.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tiles;